import { createGetter, createSetter } from '@/store/vuexUtils'
import { UserApiService } from '@/services/api/UserApiService'

const state = {
  user: null,
  isFetchingUser: false,
  userFetchedOnce: false
}

const getters = {
  userId: state => state.user ? state.user.id : null,
  isOwnedByUser: (state, getters) => userId => getters.userId === userId,
  isAdmin: state => state.user ? state.user.is_admin : false,
  user: createGetter('user')
}

const mutations = {
  STORE_USER: createSetter('user'),
  CLEAR_USER: createSetter('user', null)
}

const actions = {
  storeUser ({ commit }, user) {
    commit('STORE_USER', user)
  },
  async fetchUser ({ commit }) {
    const user = await UserApiService.fetch()
    commit('STORE_USER', user)
    return user
  },
  updateUser () {}
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
